module.exports = __webpack_public_path__ + "static/cleaning-383b047ed34a34551fac7cbe71e161b0.jpg";